<template>
  <div class="title">
    <h1 v-if="main" >
      <span v-html="title"></span><span class="dot">.</span>
    </h1>
    <h2 v-else class="astitle">
      <span v-html="title"></span><span class="dot">.</span>
    </h2>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    title: String,
    main: Boolean
  }
}
</script>

<style scoped lang="scss">
.astitle,
h1 {
  line-height: 1.3em;
  @include media-breakpoint-up(md) {
    font-size: 46px;
  }
  @include media-breakpoint-up(lg) {
    font-size: 68px;
  }
  @include media-breakpoint-only(lg) {
    font-size: 50px;
  }
  @media(max-height: 900px) and (min-width: 400px) {
    font-size: 50px;
  }

  position: relative;
}
.dot {
  color: $red;
  display: inline;
}
</style>

